import toFarsi from "./toFarsi";

function withZero(type) {
    return (type < 10 ? '0' : '') + type;
}
export function farsiDate(date) {
    const d = new Date(date);
    return d.toLocaleDateString('fa-IR');
}
export function farsiHour(date) {
    const d = new Date(date);
    return toFarsi(withZero(d.getHours())) + ":" + toFarsi(withZero(d.getMinutes()))
}
export function getFarsiDateWithMonthName(date) {
    const todayMonthName = new Date(date).toLocaleDateString("fa-IR", { month: 'long' });
    const todayMonthDay = new Date(date).toLocaleDateString("fa-IR", { day: 'numeric' });
    const todayYear = new Date(date).toLocaleDateString("fa-IR", { year: 'numeric' });
    return `${todayMonthDay} ${todayMonthName} ${todayYear}`;
}
export function getTimeDifference(date, isFuture, customPrefixes) {
    let dateNow = new Date();
    let dateEntered = new Date(date);
    if (isNaN(dateEntered.getTime())) {
        return 'نامشخص';
    }
    let difference;
    let prefixes;
    if (isFuture) {
        difference = dateEntered.getTime() - dateNow.getTime();
        prefixes = {
            year: "سال مانده",
            day: "روز مانده",
            hour: "ساعت مانده",
            minute: "دقیقه مانده",
            passed: "به اتمام رسیده"
        };
        if (customPrefixes) {
            prefixes = {...prefixes, ...customPrefixes}
        }
    } else {
        difference = dateNow.getTime() - dateEntered.getTime();
        prefixes = {
            year: "سال پیش",
            day: "روز پیش",
            hour: "ساعت پیش",
            minute: "دقیقه پیش",
            passed: "همین الان"
        };
        if (customPrefixes) {
            prefixes = {...prefixes, ...customPrefixes}
        }
    }
    const totalYears = Math.floor(difference / (1000 * 3600 * 24) / 365);
    // if it was less than a year, return days
    if (Math.ceil(difference / (1000 * 3600 * 24) / 365) <=1) {
        const totalDays = Math.ceil(difference / (1000 * 3600 * 24))
        // If it was less than a day, return hours
        if (totalDays <= 1) {
            const totalHours = Math.floor(difference / (1000 * 3600 * 24) * 24)
            // if it was less than a hour, return minutes
            if (Math.ceil(difference / (1000 * 3600 * 24) * 24) <= 1) {
                const totalMinutes = Math.floor(difference / (1000 * 3600 * 24) * 24 * 60);
                if (totalMinutes <= 0) return prefixes.passed;
                return `${totalMinutes} ${prefixes.minute}`
            }
            return `${totalHours} ${prefixes.hour}`
        }
        return `${totalDays} ${prefixes.day}`
    }
    return `${totalYears} ${prefixes.year}`
}
export function getDateTimeAsString(date) {
    return `${farsiHour(date)} - ${farsiDate(date)}`;
}